module.exports = __webpack_public_path__ + "img/reply-avatar.ef43cdba.png";